import { runbookContactService } from "../services/runbookContact.service";
import { runbookContactConstants } from "../constants/runbookContact.constants";

export const runbookContactActions = {
  get,
  getById,
  create,
  update,
  remove,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookContactService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return { type: runbookContactConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(paginatedResult) {
    return { type: runbookContactConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: runbookContactConstants.GET_FAILURE };
  }
}

function getById(runbookId, emailAddress) {
  return (dispatch) => {
    dispatch(request());

    runbookContactService.getById(runbookId, emailAddress).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: runbookContactConstants.GET_BY_ID_REQUEST };
  }
  function success(contact) {
    return { type: runbookContactConstants.GET_BY_ID_SUCCESS, payload: contact };
  }
  function failure() {
    return { type: runbookContactConstants.GET_BY_ID_FAILURE };
  }
}

function create(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookContactService.create(requestBody).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestBody) {
    return {
      type: runbookContactConstants.CREATE_REQUEST,
      payload: requestBody,
    };
  }
  function success() {
    return { type: runbookContactConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: runbookContactConstants.CREATE_FAILURE };
  }
}

function update(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookContactService.update(requestBody).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestBody) {
    return {
      type: runbookContactConstants.UPDATE_REQUEST,
      payload: requestBody,
    };
  }
  function success() {
    return { type: runbookContactConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: runbookContactConstants.UPDATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookContactService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: runbookContactConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return { type: runbookContactConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: runbookContactConstants.DELETE_FAILURE };
  }
}
